import axios from "axios";

export const baseUrl = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL + "/apoteka_rs_server"
  : "https://test.apoteka.rs:8443/apoteka_rs_server";

const instance = axios.create({
  baseURL: baseUrl,
});

instance.defaults.params = {};
instance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = "Bearer " + localStorage.getItem("token");
    config.headers["Accept-Language"] = "SR";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export default instance;
